var app = angular.module('leonardo');

var FormInput = function(ConfigThemeService, $timeout) {
  return {
    restrict: 'E',
    scope: {
      ngClass: '=?'
    },
    link: function(scope, element, attrs) {

      scope.getNgClass = function() {
        if (isEmpty(scope.ngClass)) {
          return '';
        }
        else {
          var classes = '';
          angular.forEach(scope.ngClass, function (value, key) {
            if (value){
              classes += ' ' + key;
            }
          });
          return classes;
        }
      };

      scope.$watch(
        function () {
          return element.attr('class') + scope.getNgClass();
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function() {
        $timeout(function () {
          if (attrs.backgroundColor) {
            element.css('background-color', attrs.backgroundColor);
          }
          if (element.hasClass('has-error')) {
            element.css('border-color', ConfigThemeService.getColor('errorColor'));
          }
          else {
            element.css('border-color', ConfigThemeService.getColor('tertiaryColor'));
          }
        });
      };

      if (attrs.type === 'number') {
        element.keydown(function (e) {
          if (_.contains([46, 8, 9, 27, 13, 110, 190], e.keyCode) ||
             // Allow: Ctrl/cmd+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
             // Allow: Ctrl/cmd+C
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
             // Allow: Ctrl/cmd+X
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
             // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
                 // var it happen, don't do anything
                 return;
          }
          // Ensure that it is a number and stop the keypress
          if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
              e.preventDefault();
          }
        });
        element.on('mousewheel.disableScroll', function (e) {
          e.preventDefault();
        });
        element.on('$destroy', function() {
          element.off('mousewheel.disableScroll');
        });
      }

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('input', ['ConfigThemeService', '$timeout', FormInput]);